import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DashboardService } from 'src/app/dashboard.service';
import { CheckoutService } from '../checkout.service';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {mobile} from '../../consts/utilities';

@Component({
  selector: 'app-payment-item',
  templateUrl: './payment-item.component.html',
  styleUrls: ['./payment-item.component.scss']
})
export class PaymentItemComponent implements OnInit {
    @Input() payment: any;
    @Input() checked: boolean;
    @Input() showDivider: boolean;

    @Input() setDefaultOnTap = false;
    @Input() inExpressMode = false;

    @Output() selectedPayment = new EventEmitter<any>();
    @Output() requestPaymentDeletion = new EventEmitter<any>();

    @ViewChild('deletePaymentModal')
    deletePaymentModal: TemplateRef<any>;

    isMobile: boolean;

    constructor(
        private matBottom: MatBottomSheet,
        private dialog: MatDialog,
        private dashboardService: DashboardService,
        private checkoutService: CheckoutService
    ) { }

    ngOnInit() {
        this.isMobile = mobile();
    }

    onClick(): void {
        if (this.setDefaultOnTap) {
            const id = this.payment.id;
            this.checkoutService.setDefaultPayment(id).subscribe(
                response => this.onDefaultPaymentResponse(response),
                err => this.onDefaultPaymentError(err)
            );
        }

        this.selectedPayment.emit(this.payment);
    }

    private onDefaultPaymentResponse(response: any): void {
        const { data } = response;
        // console.log(data);
    }

    private onDefaultPaymentError(err: Error): void {
        console.error(err);
    }

    onDelete(): void {
      // Delete from Conekta and calimax databases
        if (this.isMobile) {
            this.matBottom.open(this.deletePaymentModal);
        }

        if (!this.isMobile) {
            this.dialog.open(this.deletePaymentModal);
        }
    }

    dismissDeletion(): void {
        if (this.isMobile) {
            this.matBottom.dismiss();
        }

        if (!this.isMobile) {
            this.dialog.closeAll();
        }
    }

    proceedToDelete(payment: any): void {
        if (this.isMobile) {
            this.matBottom.dismiss();
        }

        if (!this.isMobile) {
            this.dialog.closeAll();
        }

        this.checkoutService.removePayment(payment).subscribe(
            response => this.onDeleteSuccessResponse(response),
            err => this.onDeleteFailedResponse(err)
        );
    }

    onDeleteSuccessResponse(response: any): void {
        this.dashboardService.spin$.next(false);
        this.requestPaymentDeletion.emit(response.data);
    }

    onDeleteFailedResponse(err: Error): void {
        console.error(err);
    }
}
